module.exports = __webpack_public_path__ + "media/images/homes/contactless_payment-d5708d1764a40f9abfdea5faba8a50ea.png";